export function loadScript(src: string) {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.onload = () => {
      resolve();
    };
    script.onerror = (e) => {
      reject(e);
    };
    document.head.appendChild(script);
  });
}
